<vl-data-table class="aeg-datatable" :mod-zebra="!emptyState || loading"
               :mod-hover="!emptyState || loading">
    <thead class="aeg-datatable-header aeg-invoices-header">
    <tr>
        <th>Titel</th>
        <th>Inhoud</th>
        <th>Periode</th>
    </tr>
    </thead>
    <tbody>
    <tr v-if="loading">
        <td colspan="7">
            <div class="aeg-datatable__loading">
                <vl-loader message="De gegevens worden geladen. Even geduld, a.u.b."/>
            </div>
        </td>
    </tr>
    <tr v-else-if="emptyState">
        <td colspan="7">
            <div class="aeg-datatable__empty">
                U heeft nog geen berichten.
            </div>
        </td>
    </tr>
    <tr class="clickable" v-else v-for="announcement in announcementList" :key="announcement.id">
        <td @click="gotoAnnouncement(announcement.id)">{{ announcement.title }}</td>
        <td @click="gotoAnnouncement(announcement.id)"><span v-html="announcement.message"></span></td>
        <td @click="gotoAnnouncement(announcement.id)">{{ formatDate(announcement) }}</td>
    </tr>
    </tbody>
</vl-data-table>